(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2655],{

/***/ 72556:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/online-counselling/[slug]",
      function () {
        return __webpack_require__(70533);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 46412:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _styles_Error_module_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(79373);
/* harmony import */ var _styles_Error_module_scss__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_styles_Error_module_scss__WEBPACK_IMPORTED_MODULE_3__);




const ErrorComponent = (props)=>{
    const { serverError  } = props;
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(()=>{
        function randomNum() {
            "use strict";
            return Math.floor(Math.random() * 9) + 1;
        }
        let increaseTimer = 0;
        const time = 30, selector3 = document.querySelector(".thirdDigit"), selector2 = document.querySelector(".secondDigit"), selector1 = document.querySelector(".firstDigit");
        const loop3 = setInterval(function() {
            "use strict";
            if (increaseTimer > 40) {
                clearInterval(loop3);
                if (selector3) selector3.textContent = serverError ? "5" : "4";
            } else {
                if (selector3) selector3.textContent = randomNum().toString();
                increaseTimer++;
            }
        }, time);
        const loop2 = setInterval(function() {
            "use strict";
            if (increaseTimer > 80) {
                clearInterval(loop2);
                if (selector2) selector2.textContent = "0";
            } else {
                if (selector2) selector2.textContent = randomNum().toString();
                increaseTimer++;
            }
        }, time);
        const loop1 = setInterval(function() {
            "use strict";
            if (increaseTimer > 100) {
                clearInterval(loop1);
                if (selector1) selector1.textContent = serverError ? "0" : "4";
            } else {
                if (selector1) selector1.textContent = randomNum().toString();
                increaseTimer++;
            }
        }, time);
    }, []);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        id: "error-component",
        className: (_styles_Error_module_scss__WEBPACK_IMPORTED_MODULE_3___default().main),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: (_styles_Error_module_scss__WEBPACK_IMPORTED_MODULE_3___default().error),
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "col-xs-12 text-center",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: (_styles_Error_module_scss__WEBPACK_IMPORTED_MODULE_3___default().containerError404),
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: (_styles_Error_module_scss__WEBPACK_IMPORTED_MODULE_3___default().clip),
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: (_styles_Error_module_scss__WEBPACK_IMPORTED_MODULE_3___default().shadow),
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                            className: `${(_styles_Error_module_scss__WEBPACK_IMPORTED_MODULE_3___default().digit)} thirdDigit`
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: (_styles_Error_module_scss__WEBPACK_IMPORTED_MODULE_3___default().clip),
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: (_styles_Error_module_scss__WEBPACK_IMPORTED_MODULE_3___default().shadow),
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                            className: `${(_styles_Error_module_scss__WEBPACK_IMPORTED_MODULE_3___default().digit)} secondDigit`
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: (_styles_Error_module_scss__WEBPACK_IMPORTED_MODULE_3___default().clip),
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: (_styles_Error_module_scss__WEBPACK_IMPORTED_MODULE_3___default().shadow),
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                            className: `${(_styles_Error_module_scss__WEBPACK_IMPORTED_MODULE_3___default().digit)} firstDigit`
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: (_styles_Error_module_scss__WEBPACK_IMPORTED_MODULE_3___default().msg),
                                    children: [
                                        "OH!",
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                            className: (_styles_Error_module_scss__WEBPACK_IMPORTED_MODULE_3___default().triangle)
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                            className: "h1",
                            children: "OOPS, SORRY WE CAN'T FIND THAT PAGE!"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                            children: "Either something went wrong or the page doesn't exist anymore."
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: (_styles_Error_module_scss__WEBPACK_IMPORTED_MODULE_3___default().btndiv),
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                                href: "/",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                    className: `${(_styles_Error_module_scss__WEBPACK_IMPORTED_MODULE_3___default().btnPrimary)}`,
                                    children: "Back to home"
                                })
                            })
                        })
                    ]
                })
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ErrorComponent);


/***/ }),

/***/ 70533:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSG": function() { return /* binding */ __N_SSG; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _components_ErrorComponent__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(46412);
/* harmony import */ var _components_OnlineCounselling_counsellingLanding__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(90235);




const OnlineCounciling = (props)=>{
    if (!props.pageData || props.pageData.length === 0) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_ErrorComponent__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {});
    }
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        const customStyle = document.documentElement.style;
        customStyle.setProperty("--navbar-color", "#0046c9");
        customStyle.setProperty("--navbar-menu-color", "#ffff");
    }, []);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: props.pageData && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_OnlineCounselling_counsellingLanding__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
            eventData: props.pageData[0]
        })
    });
};
var __N_SSG = true;
/* harmony default export */ __webpack_exports__["default"] = (OnlineCounciling);


/***/ }),

/***/ 79373:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"error":"Error_error__5J6pK","clip":"Error_clip__SVATU","shadow":"Error_shadow__FSdAk","main":"Error_main__RrWpw","digit":"Error_digit__HcJVc","btndiv":"Error_btndiv__gV_0s","btnPrimary":"Error_btnPrimary__RVY52","msg":"Error_msg__ksdYX","triangle":"Error_triangle__qa4xL","containerError404":"Error_containerError404__DhF_F"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9882,992,235,9774,2888,179], function() { return __webpack_exec__(72556); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);